// src/world/zoneRegistry.ts — Registro central de zonas (Fase 2)
import { ZONE_LABELS, type ZoneId } from '../data/gameConfig.js';
import { VILLA_AURELIA_MAP, VILLA_WARPS, VILLA_SIGNS, VILLA_SIZE } from './maps/villaAurelia.js';
import { RUTA_AURELIA_MAP, RUTA_WARPS, RUTA_SIGNS, RUTA_SIZE } from './maps/rutaAurelia.js';
import { INTERIORS, INTERIOR_SIZE } from './maps/interiors.js';
import type { Warp, SignDef } from './maps/villaAurelia.js';

export type ZoneDef = {
  id: ZoneId;
  label: string;
  size: { w:number; h:number };
  map: number[][];
  warps: Warp[];
  signs: SignDef[];
  musicKey: string; // para audioSystem
  outside: boolean; // si aplica ciclo día/noche + iluminación exterior
};

export const ZONES: Record<ZoneId, ZoneDef> = {
  villa_aurelia: {
    id: 'villa_aurelia', label: ZONE_LABELS.villa_aurelia, size: VILLA_SIZE,
    map: VILLA_AURELIA_MAP, warps: VILLA_WARPS, signs: VILLA_SIGNS, musicKey: 'villa', outside: true
  },
  ruta_aurelia: {
    id: 'ruta_aurelia', label: ZONE_LABELS.ruta_aurelia, size: RUTA_SIZE,
    map: RUTA_AURELIA_MAP, warps: RUTA_WARPS, signs: RUTA_SIGNS, musicKey: 'ruta', outside: true
  },
  casa_jugador: {
    id: 'casa_jugador', label: ZONE_LABELS.casa_jugador, size: INTERIOR_SIZE,
    map: INTERIORS.casa_jugador.map, warps: INTERIORS.casa_jugador.warps, signs: [
      { x:4, y:3, text:["Nota de mamá", "‘Mi explorador: toma el pan de la mesa y habla con Liora. ¡Aetheria te espera!’"] },
      { x:8, y:3, text:["Cama", "Aún no tienes sueño. La aventura recién empieza."] },
      { x:6, y:5, text:["Mesa", "Pan aureliano fresco. +2 al inventario (ya lo tienes)."] },
    ], musicKey: 'interior', outside: false
  },
  tienda_aurelia: {
    id: 'tienda_aurelia', label: ZONE_LABELS.tienda_aurelia, size: INTERIOR_SIZE,
    map: INTERIORS.tienda_aurelia.map, warps: INTERIORS.tienda_aurelia.warps, signs: [
      { x:3, y:2, text:["Estantería", "Cristales lumen. Brillas cuando los tocas."] },
      { x:8, y:2, text:["Caja registradora", "Liora la golpea suavemente para que suene la campanilla."] },
    ], musicKey: 'tienda', outside: false
  },
  centro_aurelia: {
    id: 'centro_aurelia', label: ZONE_LABELS.centro_aurelia, size: INTERIOR_SIZE,
    map: INTERIORS.centro_aurelia.map, warps: INTERIORS.centro_aurelia.warps, signs: [
      { x:3, y:2, text:["Cama de descanso", "Aquí las Asterias recuperan energía. Pronto..."] },
      { x:8, y:2, text:["Cama de descanso", "Sábanas con aroma a lavanda de la Pradera Cenital."] },
    ], musicKey: 'centro', outside: false
  },
  casa_npc: {
    id: 'casa_npc', label: ZONE_LABELS.casa_npc, size: INTERIOR_SIZE,
    map: INTERIORS.casa_npc.map, warps: INTERIORS.casa_npc.warps, signs: [
      { x:4, y:2, text:["Mesa de investigación", "Mapas de constelaciones y diarios. ‘Asterias de tipo Astra...’"] },
      { x:8, y:2, text:["Telescopio", "Apunta a la aurora. Alguien lo usa de noche."] },
      { x:5, y:5, text:["Libro", "‘Guía de huellas: cómo distinguir una Asteria rara por sus pisadas en hierba alta.’"] },
    ], musicKey: 'interior', outside: false
  }
};

export function getZone(id: ZoneId): ZoneDef {
  return ZONES[id] ?? ZONES.villa_aurelia;
}
